import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuditTeminalDetailsViewModel } from '../../models/audit-teminal-details-view-model';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuditService } from '../../services/audit.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuditTerminalInteractionViewModel } from '../../models/audit-teminal-interaction-details-view-model';
import { DataTableDirective } from 'angular-datatables';
import * as moment from 'moment';
import { AuditTeminalCustomParameterViewModel } from '../../models/audit-teminal-custom-parameter-view-model';

@Component({
  selector: 'app-terminal-audit-view',
  templateUrl: './terminal-audit-view.component.html',
  styleUrls: ['./terminal-audit-view.component.scss']
})
export class TerminalAuditViewComponent implements OnDestroy, OnInit {

  public terminalDetails: AuditTeminalDetailsViewModel[] = [];
  public terminalInteractions: AuditTerminalInteractionViewModel[] = [];

  public terminalGroupsAndCustomParameters: AuditTeminalCustomParameterViewModel[] = [];
  private _destroyed$ = new Subject<any>();
  public terminalNumber: string;
  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public currentDate: string;
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _route: ActivatedRoute,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _auditService: AuditService) {

    _route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      this.terminalNumber = params.id;
    });


    var today = new Date();
    // var yyyy = today.getFullYear();
    // var mm = today.getMonth();
    // var day = today.getDay();
    this.currentDate = moment(today).format('lll'); //'' + yyyy + '-' + mm + '-' + day;
  }

  ngOnInit() {
    this.dtOptions = {
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.init();
    this.resetDatatable();
  }

  public async initTable(selectedIndex: number): Promise<void> {
    if (selectedIndex == 2) {
      this.dtTrigger = new Subject();
      this.dtTrigger.next();
    }
    else if (selectedIndex == 3) {
      this.dtTrigger = new Subject();
      this.dtTrigger.next();
      //this.terminalGroupsAndCustomParameters = await this._auditService.GetTerminalCustomParams(this.terminalNumber);
    }
  }

  private async init(): Promise<void> {
    this._ngxUiLoaderService.start();
    this.terminalDetails = await this._auditService.GetTerminalDetails(this.terminalNumber);
    this.terminalInteractions = await this._auditService.GetTerminalInteractionsDetails(this.terminalNumber);
    this.terminalGroupsAndCustomParameters = await this._auditService.GetTerminalCustomParams(this.terminalNumber);

    this.dtTrigger.next();

    this._ngxUiLoaderService.stop();
  }

  public DownloadTerminalDetailsCsv(): void {
    const data = this.terminalDetails;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = ('TerminalAuditTrail_' + this.currentDate + ".csv");
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public DownloadTerminalInteractionDetailsCsv(): void {
    const data = this.terminalInteractions;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = ('TerminalAuditTrail_Interactions_' + this.currentDate + ".csv");
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  public print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('content').innerHTML;
    popupWin = window.open('', '_blank', 'top=50,left=-5,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
           <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    //this.subscription.unsubscribe();
  }

  private resetDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.draw();
      // Call the dtTrigger to rerender again
      // this.dtTrigger.next();
    });
  }

  reload() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload()
    });
  }

}
